import { Injectable, signal } from "@angular/core";
import { NetworkStatusService } from "../network-status.service";
import { LoginUserOfflineService } from "./login-user-offline.service";
import { ConnectorDbService } from "../database/connector-db.service";
import { ConnectorStatus } from "../../_objects/connector";
import { ConnectorContractService } from "../interfaces/connector-contract.service";
import { ConnectorSchema } from "../../_offline/models/connector-schema";
import { Observable } from "rxjs";
@Injectable({
  providedIn: "root"
})
export class ConnectorOfflineService implements ConnectorContractService {
  constructor(private connectorDbService: ConnectorDbService) {}

  getConnectorStatus(connectorId: string): Observable<ConnectorStatus> {
    return this.connectorDbService.getConnectorStatus(connectorId);
  }

  updateConnectorStatus(connectorStatus: ConnectorSchema): Observable<ConnectorSchema> {
    return this.connectorDbService.updateConnectorStatus(connectorStatus);
  }
}
